<script lang="ts">
	import type { OperationModel } from '@app/models/api/OperationModel';
	import { t } from 'svelte-i18n';
	import { getEntryFees } from '@app/utils/operations.js';
	import { Hint } from '@wiseed/wikit';
	import { getOperationsTypeInterestStringValue } from '@app/models/api/enums/ObligationsTypeInteretsEnum.js';
	import { OperationFinancialInstrumentEnum } from '@app/models/api/enums/OperationFinancialInstrumentEnum.js';
	import { page } from '$app/stores';

	export let operation: OperationModel;
	let fees = $page?.data?.user?.hasInvestmentFees === false ? 0 : getEntryFees(operation);
</script>

{#if operation.percentageFees >= 0 || operation.percentageManagementCosts >= 0 || operation.percentageOutingsCosts >= 0 || operation.obligationsTypeRemboursementInterets}
	{#if operation.financialInstrument !== OperationFinancialInstrumentEnum.AIF_SHARES}
		<div class="bg-dashboardBg p-4 rounded-lg">
			<div class="grid grid-cols-2 gap-3">
				{#if operation.percentageOutingsCosts >= 0}
					<div class="text-center">
						<div class="text-primary font-semibold text-xl flex items-center justify-center">
							{`${operation.percentageOutingsCosts}%`}
							<Hint
								classNames="ml-2 text-secondary"
								tooltip={{
									content: operation.isConvertibleBonds
										? $t('operation.headers.fees.convertibleBondsHintOutings')
										: $t('operation.headers.fees.hintOutings')
								}}
							/>
						</div>
						<div
							class="{operation.isConvertibleBonds
								? ''
								: 'flex items-center justify-center'} space-x-2"
						>
							<span class="first-letter:uppercase inline-block">
								{$t('operation.headers.fees.outings')}</span
							>

							{#if operation.isConvertibleBonds}
								<div class="italic text-xs">
									{$t('operation.headers.fees.convertibleBondsOutingsHelp')}
								</div>
							{/if}
						</div>
					</div>
				{/if}
				{#if operation.percentageManagementCosts >= 0}
					<div class="text-center">
						<div class="text-primary font-semibold text-xl flex items-center justify-center">
							{`${operation.percentageManagementCosts}%`}
							<Hint
								classNames="ml-2  text-secondary"
								tooltip={{
									content: $t('operation.headers.fees.hintPaymentIncluded')
								}}
							/>
						</div>
						<div class="flex items-center justify-center space-x-2">
							<span class="first-letter:uppercase"> {$t('operation.headers.fees.management')}</span>
						</div>
					</div>
				{/if}
				{#if fees >= 0}
					<div class="text-center col-span-2">
						<div class="text-primary font-semibold text-xl flex items-center justify-center">
							{`${fees}%`}
							<Hint
								classNames="ml-2 text-secondary"
								tooltip={{
									content: operation.percentageFees
										? $t('operation.headers.fees.hintPayableAddition')
										: $t('operation.headers.fees.hintPaymentIncluded')
								}}
							/>
						</div>

						{#if fees == 0}
							<div class="flex items-center justify-center space-x-2 no-wrap">
								<span class="first-letter:uppercase">
									{$t('operation.headers.fees.entry')}
								</span>
							</div>
						{:else}
							<div class="flex items-center justify-center space-x-2 no-wrap">
								<span class="first-letter:uppercase">
									{$t('operation.headers.fees.entry')}
								</span>
							</div>
						{/if}
					</div>
				{/if}
				{#if operation.obligationsTypeRemboursementInterets}
					<div class="text-center col-span-2">
						<div class="text-primary font-semibold text-xl">
							{getOperationsTypeInterestStringValue(
								operation.obligationsTypeRemboursementInterets,
								$t
							)}
						</div>
						<p class="first-letter:uppercase">{$t('operation.headers.paymentOfInterest')}</p>
					</div>
				{/if}
			</div>
		</div>
	{/if}
{/if}
